import { GOOGLE_ADS_ID, publicidadAceptada } from './cookieConsent';

const ESPERA_MAX_MS = 1000;

/**
 * Envía un evento de conversión a Google Ads
 * Se dispara al abrir WhatsApp desde los botones de "Reserva una visita"
 * Solo si la persona aceptó las cookies en el banner: sin consentimiento no se envía nada.
 *
 * Con `alTerminar`, lo llama cuando gtag confirma el envío (o como mucho a los 1000 ms, o enseguida si
 * no hay consentimiento o gtag no está, p. ej. con un bloqueador): sirve para no salir de la página
 * antes de registrarla.
 */
export const trackGoogleAdsConversion = (alTerminar?: () => void) => {
  let hecho = false;
  const fin = () => {
    if (hecho) return;
    hecho = true;
    alTerminar?.();
  };
  if (typeof window !== 'undefined' && window.gtag && publicidadAceptada()) {
    try {
      window.gtag('event', 'conversion', {
        'send_to': `${GOOGLE_ADS_ID}/ms79CLaf2O8bEKet8t9B`,
        'value': 10.0,
        'currency': 'EUR',
        ...(alTerminar ? { 'event_callback': fin } : {})
      });
    } catch {
      fin();   // un fallo de la analítica nunca bloquea el contacto
      return;
    }
    if (alTerminar) setTimeout(fin, ESPERA_MAX_MS);
  } else {
    fin();
  }
};
